import * as Sentry from "@sentry/react";

import { env } from "@/lib/env";

const dsn = env.getSentryDsn();
const isProduction = env.getIsProduction();

try {
  if (window && isProduction) {
    Sentry.init({
      dsn,
      maxValueLength: 3000,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.httpClientIntegration(),
        Sentry.replayIntegration({
          // Additional SDK configuration goes in here, for example:
          maskAllText: false,
          blockAllMedia: false,
          networkDetailAllowUrls: [window.location.origin],
          networkRequestHeaders: ["X-Custom-Header"],
          networkResponseHeaders: ["X-Custom-Header"],
        }),
        Sentry.replayCanvasIntegration(),
      ],
      tracesSampleRate: 0.1,
    });
  }
} catch (error) {
  console.info("Not in a Browser Environment");
}
